export const INPUT_TYPES = {
  ASYNC_SELECT: 'async-select',
  PASSWORD: 'password',
  TEXTAREA: 'textarea',
  CHECKBOX: 'checkbox',
  SELECT: 'select',
  TOGGLE: 'toggle',
  FILE: 'file',
  TAGS: 'tags',
  DATE: 'date',
}
